// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchArea_wrapper__FmLXF","boxWrapper":"SearchArea_boxWrapper__TQYYy","paper":"SearchArea_paper__-v1ok"};